import { Brand, Product } from './types';

// Mock catalog for flag-off mode (no live backend). Shapes mirror the SPEC
// (window.MKT.products / .brands). Live mode replaces this via GET /catalog.

export const CATEGORIES = [
  'All',
  'Smart Home',
  'Audio',
  'Accessories',
  'Home Appliances',
  'Computing',
  'Personal Care',
];

export const BRANDS: Brand[] = [
  { id: 'b1', name: 'Xiaomi', country: 'China', items: 42, rating: 4.8, verified: true, hue: 18, lead: '7–12 days' },
  { id: 'b2', name: 'Anker', country: 'China', items: 36, rating: 4.7, verified: true, hue: 250, lead: '6–10 days' },
  { id: 'b3', name: 'Sony', country: 'Japan', items: 28, rating: 4.9, verified: true, hue: 280, lead: '10–15 days' },
  { id: 'b4', name: 'Dyson', country: 'UK', items: 14, rating: 4.9, verified: true, hue: 150, lead: '12–18 days' },
  { id: 'b5', name: 'LG', country: 'South Korea', items: 31, rating: 4.6, verified: true, hue: 350, lead: '10–14 days' },
  { id: 'b6', name: 'Logitech', country: 'Switzerland', items: 22, rating: 4.7, verified: true, hue: 200, lead: '7–11 days' },
  { id: 'b7', name: 'Bosch', country: 'Germany', items: 19, rating: 4.8, verified: false, hue: 90, lead: '14–20 days' },
  { id: 'b8', name: 'Philips', country: 'Netherlands', items: 26, rating: 4.6, verified: true, hue: 30, lead: '9–13 days' },
];

export const PRODUCTS: Product[] = [
  {
    id: 'p1', name: 'Smart LED Bulb (Pack of 4)', brand: 'Xiaomi', cat: 'Smart Home', emoji: '💡', hue: 18,
    moq: 50, sold: '12K+', rating: 4.8, reviews: 214, lead: '7–12 days', stock: 8400, stockUnit: 'units',
    tiers: [{ min: 50, price: 2800 }, { min: 200, price: 2500 }, { min: 500, price: 2200 }],
    desc: 'WiFi-enabled RGB smart bulbs compatible with Alexa, Google Home and Siri. 9W, 800lm, 16M colors, E27 fitting. Retail-boxed packs of 4.',
  },
  {
    id: 'p2', name: 'Wireless Earbuds Pro X', brand: 'Sony', cat: 'Audio', emoji: '🎧', hue: 280,
    moq: 20, sold: '8K+', rating: 4.9, reviews: 187, lead: '10–15 days', stock: 3400, stockUnit: 'units',
    tiers: [{ min: 20, price: 8900 }, { min: 250, price: 8200 }, { min: 1000, price: 7400 }],
    desc: 'Active noise-cancelling earbuds, Bluetooth 5.3, dual-mic transparency. 10hr playtime + 30hr case. IPX5, USB-C.',
  },
  {
    id: 'p3', name: 'Smart LED Strip 5m', brand: 'Xiaomi', cat: 'Smart Home', emoji: '🌈', hue: 320,
    moq: 30, sold: '6K+', rating: 4.7, reviews: 142, lead: '7–12 days', stock: 8500, stockUnit: 'units',
    tiers: [{ min: 30, price: 2200 }, { min: 500, price: 1980 }, { min: 2000, price: 1750 }],
    desc: 'Flexible 5m RGB LED strip with WiFi + IR control. 12V, 300 LEDs, music sync. Includes adaptor and adhesive backing.',
  },
  {
    id: 'p4', name: 'USB-C Fast Charger 65W', brand: 'Anker', cat: 'Accessories', emoji: '🔌', hue: 250,
    moq: 40, sold: '15K+', rating: 4.8, reviews: 301, lead: '6–10 days', stock: 5000, stockUnit: 'units',
    tiers: [{ min: 40, price: 3400 }, { min: 400, price: 3050 }, { min: 1500, price: 2700 }],
    desc: 'GaN 65W charger, 2× USB-C + 1× USB-A. Charges laptops, tablets and phones at once. 40% smaller. Travel pouch included.',
  },
  {
    id: 'p5', name: 'Portable Power Bank 20000mAh', brand: 'Anker', cat: 'Accessories', emoji: '🔋', hue: 200,
    moq: 25, sold: '20K+', rating: 4.7, reviews: 412, lead: '6–10 days', stock: 1500, stockUnit: 'units',
    tiers: [{ min: 25, price: 5600 }, { min: 300, price: 5100 }, { min: 1200, price: 4600 }],
    desc: '20000mAh power bank, 22.5W fast charge, USB-C PD + USB-A. Digital display, 500+ cycles, airline-safe.',
  },
  {
    id: 'p6', name: 'Robot Vacuum Cleaner', brand: 'Dyson', cat: 'Home Appliances', emoji: '🤖', hue: 150,
    moq: 10, sold: '2K+', rating: 4.9, reviews: 98, lead: '12–18 days', stock: 60, stockUnit: 'units',
    tiers: [{ min: 10, price: 18500 }, { min: 100, price: 17200 }, { min: 500, price: 15800 }],
    desc: 'LiDAR auto-mapping robot vacuum, 2700Pa suction, 150-min runtime, auto-recharge. WiFi + app with room zoning.',
  },
  {
    id: 'p7', name: 'Air Purifier HEPA H13', brand: 'LG', cat: 'Home Appliances', emoji: '🌬️', hue: 350,
    moq: 10, sold: '3K+', rating: 4.6, reviews: 121, lead: '10–14 days', stock: 900, stockUnit: 'units',
    tiers: [{ min: 10, price: 12400 }, { min: 100, price: 11600 }, { min: 400, price: 10800 }],
    desc: 'True HEPA H13 + activated carbon 3-stage filter. Covers 45m². CADR 250m³/h. Air-quality sensor, sleep mode, child lock.',
  },
  {
    id: 'p8', name: 'Mechanical Gaming Keyboard', brand: 'Logitech', cat: 'Computing', emoji: '⌨️', hue: 200,
    moq: 20, sold: '5K+', rating: 4.7, reviews: 176, lead: '7–11 days', stock: 0, stockUnit: 'units',
    tiers: [{ min: 20, price: 7200 }, { min: 250, price: 6600 }, { min: 1000, price: 6000 }],
    desc: 'TKL mechanical keyboard, hot-swappable switches, per-key RGB, N-key rollover, aluminum top plate, detachable USB-C.',
  },
  {
    id: 'p9', name: 'Electric Toothbrush Sonic', brand: 'Philips', cat: 'Personal Care', emoji: '🪥', hue: 30,
    moq: 30, sold: '7K+', rating: 4.6, reviews: 209, lead: '9–13 days', stock: 2200, stockUnit: 'units',
    tiers: [{ min: 30, price: 4200 }, { min: 300, price: 3800 }, { min: 1200, price: 3400 }],
    desc: 'Sonic electric toothbrush, 31,000 strokes/min, 3 modes, 2-week battery, USB charging. Includes 2 brush heads.',
  },
  {
    id: 'p10', name: 'Cordless Drill 20V Kit', brand: 'Bosch', cat: 'Home Appliances', emoji: '🔧', hue: 90,
    moq: 15, sold: '1K+', rating: 4.8, reviews: 64, lead: '14–20 days', stock: 480, stockUnit: 'units',
    tiers: [{ min: 15, price: 14800 }, { min: 150, price: 13600 }, { min: 600, price: 12400 }],
    desc: '20V brushless cordless drill kit, 2 batteries, charger, 50-piece bit set, carry case. 1700 RPM, LED work light.',
  },
];
